import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Drag-to-reorder the funnel's step rail. On drop, PATCH the full
// ordered id list to the reorder endpoint, then reload so the step
// numbers/positions re-render from server truth (also the recovery
// path when the save fails or the list was stale).
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-reorder-handle]",
      ghostClass: "opacity-40",
      onEnd: (event) => {
        if (event.oldIndex !== event.newIndex) this.persist();
      },
    });
  }

  disconnect() {
    this.sortable?.destroy();
  }

  async persist() {
    const ids = Array.from(this.element.querySelectorAll("[data-step-id]")).map(
      (el) => el.dataset.stepId,
    );
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    try {
      const res = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ step_ids: ids }),
      });
      if (!res.ok) throw new Error("reorder failed");
    } finally {
      this.reload();
    }
  }

  reload() {
    if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: "replace" });
    } else {
      window.location.reload();
    }
  }
}
